import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { variables } from "../Variables/Variable";

const Content = () => {
  const ID = useParams();
  const [productList, setProductList] = useState([]);
  const [filteredList, setFilteredList] = useState([]);
  const [menu, setMenu] = useState({});
  const [filters, setFilters] = useState([]);
  const [selectedFilters, setSelectedFilters] = useState([]);

  const getItemsBySearch = () => {
    fetch(variables.API_URL + "Content/SearchContents/" + encodeURIComponent(ID.Search), {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (response.ok) return response.json();
        throw new Error("Failed to fetch content");
      })
      .then((result) => {
        console.log("Search Results:", result);

        // Flatten data (each result contains MenuDetails, Content, Filters)
        const allContents = result.map((r) => r.Content);
        const allFilters = result.flatMap((r) => r.Filters);
        const firstMenu = result[0]?.MenuDetails || {};

        setProductList(allContents);
        setFilteredList(allContents);
        setMenu(firstMenu);

        // Combine filters by unique AttributeId
        const uniqueFilters = [];
        allFilters.forEach((filter) => {
          const existing = uniqueFilters.find((f) => f.AttributeId === filter.AttributeId);
          if (!existing) {
            uniqueFilters.push(filter);
          }
        });

        setFilters(uniqueFilters);
      })
      .catch((error) => console.error("Error:", error));
  };

  // === FILTERING ===
  const filterArray = (array, filters) => {
    const filterKeys = Object.keys(filters);
    return array.filter((item) => {
      return filterKeys.every((key) => {
        if (typeof filters[key] !== "function") return true;
        const filterArrayId = selectedFilters.map((item) => parseInt(item.AttributeValue));
        const arrayTrues = filterArrayId.map((fai) =>
          item[key].some((d) => fai === d.CustomFieldDataId)
        );
        return arrayTrues.every((atv) => atv === true);
      });
    });
  };

  const FilterProduct = async (e, index) => {
    const { value } = e.target;
    if (value.length !== 0) {
      if (!handleCheck(index)) {
        selectedFilters.push({ index: index, AttributeValue: value });
      } else {
        handleReplace(selectedFilters, index, value);
      }
    } else {
      if (handleCheck(index)) {
        removeByAttr(selectedFilters, "index", index, value);
      }
    }

    const array = selectedFilters.map((item) => parseInt(item.AttributeValue));
    const filters = {
      details: (details) => details.find((x) => array.includes(x.CustomFieldDataId)),
    };
    const filtered = filterArray(productList, filters);
    setFilteredList(filtered);
  };

  const removeByAttr = function (arr, attr, value) {
    var i = arr.length;
    while (i--) {
      if (
        arr[i] &&
        arr[i].hasOwnProperty(attr) &&
        arguments.length > 2 &&
        arr[i][attr] === value
      ) {
        arr.splice(i, 1);
      }
    }
    return arr;
  };

  const handleCheck = (val) => {
    var b = selectedFilters.find((a) => a.index === val);
    return b !== undefined;
  };

  var handleReplace = function (arr, index, value) {
    const b = selectedFilters.findIndex((a) => a.index === index);
    if (b !== -1) {
      arr[b].AttributeValue = value;
      return arr;
    }
  };

  useEffect(() => {
    getItemsBySearch();
  }, [ID.Search]);

  return (
    <>
      {/* Page Header */}
      <section className="page-header">
        <div
          className="page-header__bg"
          style={{ backgroundImage: `url(${variables.PHOTO_URL + menu.ImageUrl})` }}
        ></div>
        <div className="container">
          <div className="row">
            <div className="col-xl-12">
              <div className="page-header__wrapper">
                <div className="page-header__content">
                  <h2>Search: {ID.Search}</h2>
                  <div className="page-header__menu">
                    <ul>
                      <li><a hreflang="en" href="/">Home</a></li>
                      <li>Search Results</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Filters */}
      <section className="services-two services-two--services-two">
        <div className="container">
          <div className="sec-title text-center">
            <p className="sec-title__text">{menu.MetaDescription}</p>
          </div>

          <div className="dropdown_filter_main">
            {filters.map((filter, index) => (
              <div className="dropdown_filter_inner" key={filter.AttributeId}>
                <select
                  className="inputBoxSelect"
                  id={"CustomFieldData" + index}
                  name={filter.AttributeName}
                  onChange={(e) => FilterProduct(e, index)}
                >
                  <option value="">{filter.AttributeName}</option>
                  {filter.AttributeValues.map((Attr) => (
                    <option key={Attr.AttributeValueId} value={Attr.AttributeValueId}>
                      {Attr.AttributeName}
                    </option>
                  ))}
                </select>
              </div>
            ))}
          </div>
        </div>

        {/* Results */}
        <div className="row">
          {filteredList.map((product) => (
            <div className="col-xl-4 col-lg-4 col-md-6" key={product.ContentId}>
              <div
                className="services-two__single wow animated fadeInUp"
                data-wow-delay="0.1s"
              >
                <div className="services-two__single-img">
                  <a hreflang="en" href={"/" + product.Url}>
                    <img
                      src={variables.PHOTO_URL + product.ImageUrl}
                      alt={product.ContentTitle}
                    />
                  </a>
                </div>

                <div className="services-two__single-content text-center">
                  <h2>
                    <a hreflang="en" href={"/" + product.Url}>{product.ContentTitle}</a>
                  </h2>
                  <p>{product.SmallDescription}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default Content;
